import { cn } from "@/helpers/tailwind";
import React from "react";

interface DottedSeparatorProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

export const DottedSeparator: React.FC<DottedSeparatorProps> = ({
  className,
  ...props
}) => (
  <svg className={cn("h-[2px]", className)} {...props}>
    <line
      x1="0"
      y1="1"
      x2="100%"
      y2="1"
      stroke="#475569"
      strokeWidth="1.5"
      strokeDasharray="2 4"
    />
  </svg>
);
